<!-- 全景数据展板 -->
<template>
    <div class="resource-data-board">
      <div class="resource-data-board-left">
          <!-- 资源访问 -->
        <resource-visit></resource-visit>
          <!-- 资源分布 -->
          <resource-distribution></resource-distribution>
          <!-- 题库建设 -->
          <question-bank-build></question-bank-build>
      </div>
      <div class="resource-data-board-content">
        <teaching-dynamics></teaching-dynamics>
        <!-- 区本资源 -->
        <district-based-resources></district-based-resources>
      </div>
      <div class="resource-data-board-right">
          <!-- 活跃学校TOP5 -->
          <active-school-rank></active-school-rank>
          <!-- 活跃资源TOP5 -->
          <active-resource></active-resource>
      </div>
    </div>
  </template>
  <script>
  import ResourceVisit from "@/views/site/modules/ResourceVisit.vue"
  import ResourceDistribution from "@/views/site/modules/ResourceDistribution.vue"
  import QuestionBankBuild from "@/views/site/modules/QuestionBankBuild.vue"
  import TeachingDynamics from "@/views/site/modules/TeachingDynamics.vue"
  import DistrictBasedResources from "@/views/site/modules/DistrictBasedResources.vue"
  import ActiveSchoolRank from "@/views/site/modules/ActiveSchoolRank.vue"
  import ActiveResource from "@/views/site/modules/ActiveResource.vue"
  export default {
    name: 'resource',
    components:{
        ResourceVisit,
        ResourceDistribution,
        QuestionBankBuild,
        TeachingDynamics,
        DistrictBasedResources,
        ActiveSchoolRank,
        ActiveResource
    },
    data() {
      return {
  
      }
    },
    methods: {
  
    },
    watch: {
  
    },
    computed: {
  
    },
    mounted() {
    },
  }
  </script>
  <style lang="scss" scoped>
 @font-face {
    font-family: DigifaceWide;
    src: url('../../../assets/fonts/DigifaceWide Regular.ttf'); //字体路径
}
.resource-data-board{
  display: flex;
  // align-items: center;
  justify-content: space-between;
  width: 100%;
  .resource-data-board-left{
    width: calc(25% - 10px);
  }
  .resource-data-board-content{
    width: calc(50% - 20px);
  }
  .resource-data-board-right{
    width: calc(25% - 10px);
  }
}
  </style>